import { render, staticRenderFns } from "./payment-fail.component.vue?vue&type=template&id=2dd67eec&scoped=true"
import script from "./payment-fail.component.ts?vue&type=script&lang=ts&external"
export * from "./payment-fail.component.ts?vue&type=script&lang=ts&external"
import style0 from "./payment-fail.component.vue?vue&type=style&index=0&id=2dd67eec&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd67eec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dd67eec')) {
      api.createRecord('2dd67eec', component.options)
    } else {
      api.reload('2dd67eec', component.options)
    }
    module.hot.accept("./payment-fail.component.vue?vue&type=template&id=2dd67eec&scoped=true", function () {
      api.rerender('2dd67eec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/payment/checkout/payment-fail.component.vue"
export default component.exports